<div
  class="contract-type-switch"
  #container
  [tabIndex]="tabIndex"
  (keydown)="onKeydown($event)"
  cdkMonitorSubtreeFocus
  (cdkFocusChange)="onFocusChange($event)"
  (focus)="onFocus()"
>
  <div
    class="contract-type-switch__indicator"
    [class.contract-type-switch__indicator--rent]="
      currentOption.value === 'rent'
    "
  ></div>

  <button
    class="contract-type-switch-option"
    [class.contract-type-switch-option--active]="
      option.value === currentOption.value
    "
    [style.width]="buttonWidth"
    *ngFor="let option of options; trackBy: trackBy"
    (click)="select(option)"
    tabindex="-1"
    libListButton
  >
    <span class="contract-type-switch-option__text">
      {{ option.text | i18n }}
    </span>
  </button>
</div>
